import { Component } from 'react';
import dynamic from 'next/dynamic';
import Model3dConverterShell from './model3d-converter.shell';

// SSR-able wrapper. Renders the static shell (with the feature/slug baked
// in) server-side, then swaps in the real three.js-powered editor after
// hydration. The dynamic import is `ssr: false` because three.js's
// example/jsm/loaders touch WebGLRenderingContext at module-load.
const Model3dConverterReal = dynamic(
    () => import('./model3d-converter.component'),
    { ssr: false, loading: () => <Model3dConverterShell /> },
);

interface State { mounted: boolean }

export default class Model3dConverterWrapper extends Component<{ feature?: string }, State> {
    state: State = { mounted: false };

    componentDidMount() {
        this.setState({ mounted: true });
    }

    render() {
        if (!this.state.mounted) return <Model3dConverterShell feature={this.props.feature} />;
        return <Model3dConverterReal feature={this.props.feature} />;
    }
}
